
const immutable = Object.freeze;

export const week_days = immutable(["sun", "mon", "tue", "wen", "thu", "fri", "sat"]);

// NOTE: Could be changed to match any desired language.
export const week_day_to_locale = immutable({
  "sun": "dom",
  "mon": "seg",
  "tue": "ter",
  "wen": "qua",
  "thu": "qui",
  "fri": "sex",
  "sat": "sab",
});
export const week_day_locale = immutable(["dom", "seg", "ter", "qua", "qui", "sex", "sab"]);

export default {
  week_day_to_locale,
  week_day_locale,
  week_days,
  methods: {
    /**
     * @typedef {"mon" | "tue" | "wen" | "thu" | "fri" | "sat" | "sun"} WeekDay
     */

    /**
     * Encodes a single day of the week string into a single byte.
     * @param {WeekDay} day
     * @returns {number} The encoded day into a byte.
     */
    week_day_encodeUint8(day) {
      return 1 << week_days.findIndex(d => d === day);
    },

    /**
     * Encodes many days of the week into a single byte.
     * @param {WeekDay[]} days 
     * @returns {number} The encoded days into a byte
     */
    week_days_encodeUint8(days) {
      return days.reduce((acc, day) => acc | this.week_day_encodeUint8(day), 0)
    }
  }
};
